import Dashboard from "views/Dashboard.js";
import UserPage from "views/Users";
import ManageUser from "views/Users/AddEdit";

import Districts from "views/Districts";
import DistrictOperations from "views/Districts/AddEdit"

import Blocks from "views/Blocks";
import BlockOperations from "views/Blocks/AddEdit"

import GramPanchayats from "views/GramPanchayats";
import GramPanchayatOperations from "views/GramPanchayats/AddEdit";

import CategoryOperations from "views/Categories/AddEdit";
import CategoryList from "views/Categories";

import DepartmentOperations from "views/Departments/AddEdit";
import DepartmentList from "views/Departments";

import SchemesOperations from "views/Schemes/AddEdit";
import SchemesList from "views/Schemes";

import ApplicationOperations from 'views/Applications/AddEdit';
import Applications from "views/Applications";

import CampaignOperations from 'views/Campaign/AddEdit';
import CampaignList from "views/Campaign";


import Report from "views/Reports/reports";
import DepartmentReport from "views/Reports/department_report";
import DistrictReport from "views/Reports/district_report";
import SchemeReport from "views/Reports/scheme_report";
import BlockReport from 'views/Reports/block_report'
import GramPanchayatReport from 'views/Reports/gram_panchayat_report'

let icons = {
  dashboard: 'nc-bank',
  application: 'nc-paper',
  categories: 'nc-bullet-list-67',
  schemes: 'nc-single-copy-04',
  department: 'nc-layout-11',
  district: 'nc-world-2',
  officer: 'nc-single-02',
  report: 'nc-chart-pie-36',
  admin: 'nc-badge'
}

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon " + icons.dashboard,
    component: Dashboard,
    canShowInSideBar: true,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2, 3, 4, 5, 6, 7]
  },
  {
    path: "/application",
    name: "Applications",
    icon: "nc-icon " + icons.application,
    component: Applications,
    canShowInSideBar: true,
    layout: "/admin",
    requiredRoleIds: [1, 2, 4, 5, 6, 7]
  },
  {
    path: "/applications/operations/:application_id?",
    name: "Applications",
    icon: "nc-icon " + icons.application,
    component: ApplicationOperations,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2, 4, 5, 6]
  },
  {
    path: "/category",
    name: "Categories",
    icon: "nc-icon " + icons.categories,
    component: CategoryList,
    canShowInSideBar: true,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2]
  },
  {
    path: "/category/operations/:category_id?",
    name: "Categories",
    icon: "nc-icon " + icons.categories,
    component: CategoryOperations,
    canShowInSideBar: false,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2]
  },
  {
    path: "/schemes",
    name: "Schemes",
    icon: "nc-icon " + icons.schemes,
    component: SchemesList,
    canShowInSideBar: true,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2]
  },
  {
    path: "/schemes/operations/:scheme_id?",
    name: "Schemes",
    icon: "nc-icon " + icons.schemes,
    component: SchemesOperations,
    canShowInSideBar: false,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2]
  },
  {
    path: "/departments",
    name: "Departments",
    icon: "nc-icon " + icons.department,
    component: DepartmentList,
    canShowInSideBar: true,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2]
  },
  {
    path: "/departments/operations/:department_id?",
    name: "Departments",
    icon: "nc-icon " + icons.department,
    component: DepartmentOperations,
    canShowInSideBar: false,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2]
  },
  {
    path: "/campaign",
    name: "Campaigns",
    icon: "nc-icon " + icons.department,
    component: CampaignList,
    canShowInSideBar: true,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2, 7]
  },
  {
    path: "/campaign/operations/:campaign_id?",
    name: "Campaign",
    icon: "nc-icon " + icons.department,
    component: CampaignOperations,
    canShowInSideBar: false,
    layout: "/admin",
    isExact: true,
    requiredRoleIds: [1, 2, 7]
  },
  {
    path: "/districts",
    id: "district-block",
    name: "District / Block / Gram panchayat",
    icon: "nc-icon " + icons.district,
    isExact: true,
    component: Districts,
    requiredRoleIds: [1, 2],
    subRoutes: [
      {
        path: "/districts",
        name: "Districts",
        icon: "nc-icon " + icons.district,
        component: Districts,
        canShowInSideBar: true,
        layout: "/admin",
        requiredRoleIds: [1, 2],
        isExact: true,
      },
      {
        path: "/districts/operations/:district_id?",
        name: "Districts Operations",
        icon: "nc-icon " + icons.district,
        component: DistrictOperations,
        layout: "/admin",
        requiredRoleIds: [1, 2],
        canShowInSideBar: false,
        isExact: true,
      },
      {
        path: "/blocks",
        name: "Blocks",
        icon: "nc-icon " + icons.district,
        component: Blocks,
        requiredRoleIds: [1, 2],
        layout: "/admin",
        canShowInSideBar: true,
        isExact: true,
      },
      {
        path: "/blocks/operations/:block_id?",
        name: "Block Operations",
        layout: "/admin",
        requiredRoleIds: [1, 2],
        icon: "nc-icon " + icons.district,
        component: BlockOperations,
        canShowInSideBar: false,
        isExact: true,
      },
      {
        path: "/gram_panchayat",
        layout: "/admin",
        requiredRoleIds: [1, 2],
        name: "Gram Panchayats",
        icon: "nc-icon " + icons.district,
        component: GramPanchayats,
        canShowInSideBar: true,
        isExact: true,
      },
      {
        path: "/gram_panchayat/operations/:gp_id?",
        name: "Gram Panchayat Operations",
        icon: "nc-icon " + icons.district,
        layout: "/admin",
        requiredRoleIds: [1, 2],
        component: GramPanchayatOperations,
        canShowInSideBar: false,
        isExact: true,
      },
    ],
    canShowInSideBar: true,
    layout: "/admin",
  },
  {
    path: "/district_officer",
    name: "Department District Officers",
    icon: "nc-icon " + icons.officer,
    component: UserPage,
    layout: "/admin",
    requiredRoleIds: [4],
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/field_officer",
    name: "Department Field Officers",
    icon: "nc-icon " + icons.officer,
    component: UserPage,
    requiredRoleIds: [5],
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/officers",
    id: "officers-block",
    name: "User management",
    icon: "nc-icon " + icons.officer,
    isExact: true,
    component: UserPage,
    requiredRoleIds: [1, 2],
    subRoutes: [
      {
        path: "/director",
        name: "Directors",
        layout: "/admin",
        icon: "nc-icon " + icons.officer,
        component: UserPage,
        requiredRoleIds: [1, 2],
        canShowInSideBar: true,
        isExact: true,
      },
      {
        path: "/department_officer",
        name: "Department Head Officers",
        icon: "nc-icon " + icons.officer,
        layout: "/admin",
        component: UserPage,
        requiredRoleIds: [1, 2],
        canShowInSideBar: true,
        isExact: true,
      },
      {
        path: "/dpm",
        name: "District Program Manager",
        icon: "nc-icon " + icons.officer,
        component: UserPage,
        layout: "/admin",
        requiredRoleIds: [1, 2],
        canShowInSideBar: true,
        isExact: true,
      },
      {
        path: "/district_officer",
        name: "Department District Officers",
        icon: "nc-icon " + icons.officer,
        component: UserPage,
        requiredRoleIds: [1, 2],
        layout: "/admin",
        canShowInSideBar: true,
        isExact: true,
      },
      {
        path: "/field_officer",
        name: "Department Field Officers",
        icon: "nc-icon " + icons.officer,
        component: UserPage,
        layout: "/admin",
        requiredRoleIds: [1, 2],
        canShowInSideBar: true,
        isExact: true,
      },
      {
        path: "/users/operations/:role_id/:user_id?",
        name: "User Operation",
        icon: "nc-icon " + icons.officer,
        requiredRoleIds: [1, 2],
        component: ManageUser,
        layout: "/admin",
        canShowInSideBar: false,
        isExact: true,
      }
    ],
    canShowInSideBar: true,
    layout: "/admin",
  },
  {
    path: "/administrator-section",
    id: "administrator-block",
    name: "Administrator",
    icon: "nc-icon " + icons.admin,
    isExact: true,
    component: UserPage,
    requiredRoleIds: [1, 2],
    subRoutes: [
      {
        path: "/users/operations/2",
        name: "Add new admin",
        icon: "nc-icon " + icons.admin,
        component: UserPage,
        requiredRoleIds: [1, 2],
        layout: "/admin",
        canShowInSideBar: true,
        isExact: true,
      },
      {
        path: "/administrator",
        name: "Admin users",
        icon: "nc-icon " + icons.admin,
        component: UserPage,
        requiredRoleIds: [1, 2],
        layout: "/admin",
        canShowInSideBar: true,
        isExact: true,
      },
    ],
    canShowInSideBar: true,
    layout: "/admin",
  },
  {
    path: "/reports",
    id: "report-block",
    name: "Reports",
    icon: "nc-icon " + icons.report,
    isExact: true,
    component: Report,
    requiredRoleIds: [1, 2, 4],
    subRoutes: [
      {
        path: "/reports",
        name: "Report",
        icon: "nc-icon " + icons.report,
        component: Report,
        requiredRoleIds: [1, 2, 4],
        canShowInSideBar: true,
        layout: "/admin",
        isExact: true,
      },
      {
        path: "/district_report",
        name: "District report",
        icon: "nc-icon " + icons.report,
        component: DistrictReport,
        requiredRoleIds: [1, 2, 4],
        canShowInSideBar: true,
        layout: "/admin",
        isExact: true,
      },
      {
        path: "/block_report/:district_id?",
        name: "Block report",
        icon: "nc-icon " + icons.report,
        component: BlockReport,
        requiredRoleIds: [1, 2],
        layout: "/admin",
        isExact: true,
      },
      {
        path: "/gp_report/:district_id?/:block_id?",
        name: "GramPanchayat report",
        icon: "nc-icon " + icons.report,
        component: GramPanchayatReport,
        layout: "/admin",
        requiredRoleIds: [1, 2],
        isExact: true,
      },
      {
        path: "/department_report",
        name: "Department report",
        icon: "nc-icon " + icons.report,
        requiredRoleIds: [1, 2],
        component: DepartmentReport,
        canShowInSideBar: true,
        isExact: true,
        layout: "/admin",
      },
      {
        path: "/scheme_report",
        name: "Scheme report",
        icon: "nc-icon " + icons.report,
        component: SchemeReport,
        layout: "/admin",
        requiredRoleIds: [1, 2],
        canShowInSideBar: true,
        isExact: true,
      }
    ],
    canShowInSideBar: true,
    layout: "/admin",
  },
  {
    path: "/report",
    name: "Report",
    icon: "nc-icon " + icons.report,
    component: Report,
    canShowInSideBar: true,
    isExact: true,
    layout: "/admin",
    requiredRoleIds: [3, 5],
  },
  {
    path: "/block_report",
    name: "Block Report",
    icon: "nc-icon " + icons.report,
    component: BlockReport,
    canShowInSideBar: true,
    isExact: true,
    layout: "/admin",
    requiredRoleIds: [7],
  },
];
export default routes;
